export default __webpack_public_path__ + "9708edb1482eed20d7027d82f8c75194.woff";